<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Yeni Etkinlik Ekle">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span><strong>Not:</strong> Eklenecek etlinlik adı ve arama motoru bağlantı
                linki benzersiz olmalıdır...</span>
            </div>
          </b-alert>
          <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" to="/events">
            Etlinlik Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Etkinlik Özellikleri">
            <b-row>
              <b-col md="3">
                <b-form-group label="Etkinlik Tipi" label-for="type">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Etkinlik Tipi">
                    <v-select id="type" v-model="selectedEventType" label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="eventTypes" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group label="Kategoriler" label-for="categories">
                  <validation-provider #default="{ errors }" :rules="{
                    required: true,
                  }" name="Kategoriler">
                    <v-select id="educators" v-model="selectedCategory" label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="categories" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="İçerikler" label-for="contents">
                  <validation-provider #default="{ errors }" :rules="{ required: false }" name="İçerikler">
                    <v-select id="contents" v-model="selectedContent" label="title"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="contents" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <b-card class="mb-3" title="Etkinlik Ekleme Formu">
            <b-row :style="educatorsVisibility ? 'display:flex;' : 'display:none;'">
              <b-col md="12">
                <b-form-group label="Eğitmenler (Yok ise boş bırakın)" label-for="educators">
                  <validation-provider #default="{ errors }" :rules="{
                    required: false,
                  }" name="Eğitmenler (Yok ise boş bırakın)">
                    <v-select id="educators" v-model="selectedEducators"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="fullName" multiple
                      :options="educators" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Galeri (Yok ise boş bırakın)" label-for="galleries">
                  <validation-provider #default="{ errors }" :rules="{ required: false }"
                    name="Galeri (Yok ise boş bırakın)">
                    <v-select id="galleries" v-model="selectedGallery"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="galleries" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Başlık" label-for="title">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Başlık">
                    <b-form-input id="title" v-model="title" placeholder="Başlık"
                      :state="errors.length > 0 ? false : null"
                      :class="title.length >= chars.title ? 'text-danger' : ''" />
                    <small class="textarea-counter-value float-right"
                      :class="title.length >= chars.title ? 'bg-danger' : ''">
                      <span class="char-count">{{ title.length }}</span>
                      /
                      {{ chars.title }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Bağlantı Başlığı" label-for="linktTitle">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Bağlantı Başlığı">
                    <b-form-input id="linkTitle" v-model="linkTitle" placeholder="Bağlantı Başlığı"
                      :state="errors.length > 0 ? false : null"
                      :class="linkTitle.length >= chars.linkTitle ? 'text-danger' : ''" />
                    <small class="textarea-counter-value float-right"
                      :class="linkTitle.length >= chars.linkTitle ? 'bg-danger' : ''">
                      <span class="char-count">{{ linkTitle.length }}</span>
                      /
                      {{ chars.linkTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="İçerik" label-for="text">
                  <!-- <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="İçerik"
                  > -->
                  <editor ref="refEditor"></editor>

                  <!-- <quill-editor
                      id="text"
                      v-model="text"
                      :options="snowOption"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <DragDropImage ref="refCardImage" dimensions="1440x720" title="Kart Görseli" :imageUrl="null" :required="true">
                </DragDropImage>
              </b-col>
              <b-col md="4">
                <b-form-group label="Görsel Başlığı (title)" label-for="imageTitle">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Görsel Başlığı (title)">
                    <b-form-textarea id="imageTitle" v-model="imageTitle" placeholder="Görsel Başlığı (title)" rows="3"
                      class="char-textarea" :state="errors.length > 0 ? false : null"
                      :class="imageTitle.length >= chars.imageTitle ? 'text-danger' : ''" />
                    <small class="textarea-counter-value float-right"
                      :class="imageTitle.length >= chars.imageTitle ? 'bg-danger' : ''">
                      <span class="char-count">{{ imageTitle.length }}</span>
                      /
                      {{ chars.imageTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Görsel Açıklaması (alt text)" label-for="imageAltText">
                  <validation-provider #default="{ errors }" :rules="{ required: true }"
                    name="Görsel Açıklaması (alt text)">
                    <b-form-textarea id="imageAltText" v-model="imageAltText" placeholder="Görsel Açıklaması (alt text)"
                      rows="3" class="char-textarea" :state="errors.length > 0 ? false : null" :class="imageAltText.length >= chars.imageAltText ? 'text-danger' : ''
                        " />
                    <small class="textarea-counter-value float-right" :class="imageAltText.length >= chars.imageAltText ? 'bg-danger' : ''
                      ">
                      <span class="char-count">{{ imageAltText.length }}</span>
                      /
                      {{ chars.imageAltText }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-checkbox class="mb-2" v-model="isHeroHide" checked="false" switch inline>
                  Kart Görselini Gizle
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Bağlantı Linki" label-for="slug">
                  <validation-provider #default="{ errors }" rules="required" name="Bağlantı Linki">
                    <b-form-input id="slug" v-model="slug" placeholder="Bağlantı Linki"
                      :state="errors.length > 0 || availability == false ? false : null" :class="slug.length >= chars.slug || availability == false
                          ? 'text-danger'
                          : ''
                        " />
                    <small class="textarea-counter-value float-right"
                      :class="slug.length >= chars.slug ? 'bg-danger' : ''">
                      <span class="char-count">{{ slug.length }}</span>
                      /
                      {{ chars.slug }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <div v-if="availability == false">
                    <p class="text-danger">
                      <small>İçerik linki benzersiz olmalıdır.</small>
                    </p>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Meta Açıklaması" label-for="metaTitle">
                  <validation-provider #default="{ errors }" :rules="{ required: true, min: 30 }"
                    name="Meta Açıklaması">
                    <b-form-textarea id="metaTitle" v-model="metaDescription" placeholder="Meta Açıklaması" rows="3"
                      class="char-textarea" :state="errors.length > 0 ? false : null" :class="metaDescription.length >= chars.metaDescription
                          ? 'text-danger'
                          : ''
                        " />
                    <small class="textarea-counter-value float-right" :class="metaDescription.length >= chars.metaDescription ? 'bg-danger' : ''
                      ">
                      <span class="char-count">{{ metaDescription.length }}</span>
                      /
                      {{ chars.metaDescription }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Bilet Linki" label-for="ticketLink">
                  <validation-provider #default="{ errors }" :rules="{ required: false }" name="Bilet Linki">
                    <b-form-input id="ticketLink" v-model="ticketLink" placeholder="Bilet Linki" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2" class="mb-2">
                <validation-provider #default="{ errors }" :rules="{ required: true }"
                  name="Bilet Linki (Yok ise boş bırakın)">
                  <b-form-checkbox v-model="isTicketsAreSoldOut" checked="true" switch inline>
                    Bilet Tükendi
                  </b-form-checkbox>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Etkinlik Yeri" label-for="place">
                  <validation-provider name="Etkinlik Yeri">
                    <b-form-textarea id="place" v-model="place" placeholder="Etkinlik Yeri" rows="3"
                      class="char-textarea" />
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Etkinlik Adresi" label-for="address">
                  <validation-provider name="Etkinlik Adresi">
                    <b-form-textarea id="address" v-model="address" placeholder="Etkinlik Adresi" rows="3"
                      class="char-textarea" />
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-checkbox class="mb-2" v-model="formIsActive" checked="false" switch inline>
                  Etkinlik Formu Aktif (Etkinlik oluşturulduktan sonra aktif olur)
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row :style="formIsActive ? 'display:flex;' : 'display:none;'">
              <b-col md="12">
                <b-form-group label="Form Şablonları" label-for="eventFormTemplates">
                  <validation-provider #default="{ errors }" :rules="{
                    required: formIsActive,
                  }" name="Form Şablonları">
                    <v-select id="eventFormTemplates" v-model="selectedEventFormTemplate"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name" :options="eventFormTemplates" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row :style="formIsActive ? 'display:flex;' : 'display:none;'">
              <b-col md="12">
                <b-form-group label="Form Adı" label-for="formName">
                  <validation-provider #default="{ errors }" :rules="{ required: formIsActive }" name="Form Adı">
                    <b-form-input id="formName" v-model="formName" placeholder="Form Adı" rows="3" class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="formName.length >= chars.formName ? 'text-danger' : ''" />
                    <small class="textarea-counter-value float-right"
                      :class="formName.length >= chars.formName ? 'bg-danger' : ''">
                      <span class="char-count">{{ formName.length }}</span>
                      /
                      {{ chars.formName }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Tarihler" label-for="text">
                  <div>
                    <b-form ref="form" :style="{ height: trHeight }" class="repeater-form"
                      @submit.prevent="repeateAgain">
                      <!--  Loop -->
                      <div v-for="(date, index) in dates" :id="date.id" :key="date.id" ref="row">
                        <b-row>
                          <hr />
                        </b-row>
                        <b-row>
                          <b-col md="12">
                            <b-form-group label="Başlık" label-for="title">
                              <validation-provider #default="{ errors }" :rules="{
                                required: true,
                              }" name="Başlık">
                                <b-form-input v-model="dates[index].title" placeholder="Başlık"
                                  :state="errors.length > 0 ? false : null" :class="title.length >= chars.title ? 'text-danger' : ''
                                    " />
                                <small class="textarea-counter-value float-right"
                                  :class="title.length >= chars.title ? 'bg-danger' : ''">
                                  <span class="char-count">{{ title.length }}</span>
                                  /
                                  {{ chars.title }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- startDate -->
                          <b-col md="4">
                            <b-form-group label="Başlangıç Tarihi" label-for="startDate">
                              <b-form-datepicker v-model="dates[index].startDate" v-bind="translation || {}"
                                :locale="locale" :start-weekday="weekday" :show-decade-nav="showDecadeNav"
                                :hide-header="hideHeader" class="mb-1" />
                            </b-form-group>
                          </b-col>
                          <!-- startTime -->
                          <b-col md="4">
                            <b-form-group label="Başlangıç Saati" label-for="startTime">
                              <vue-timepicker v-model="dates[index].startTime" format="HH:mm"
                                manual-input></vue-timepicker>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- endDate -->
                          <b-col md="4">
                            <b-form-group label="Bitiş Tarihi" label-for="endDate">
                              <b-form-datepicker v-model="dates[index].endDate" v-bind="translation || {}"
                                :locale="locale" :start-weekday="weekday" :show-decade-nav="showDecadeNav"
                                :hide-header="hideHeader" class="mb-1" />
                            </b-form-group>
                          </b-col>
                          <!-- endTime -->
                          <b-col md="4">
                            <b-form-group label="Bitiş Saati" label-for="endTime">
                              <vue-timepicker v-model="dates[index].endTime" format="HH:mm"
                                manual-input></vue-timepicker>
                            </b-form-group>
                          </b-col>
                          <b-col md="2">
                            <b-form-group label="Bitiş Saatini Gizle" label-for="endTime">
                              <b-form-checkbox v-model="dates[index].endTimeVisibility" class="mt-1" checked="true"
                                switch inline>
                                Bitiş Saatini Gizle
                              </b-form-checkbox>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Remove Button -->
                          <b-col lg="2" md="3" class="mb-50">
                            <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger"
                              class="mt-0 mt-md-2" @click="removeItem(index)">
                              <feather-icon icon="XIcon" class="mr-25" />
                              <span>Sil</span>
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-col cols="12">
                          <hr />
                        </b-col>
                      </div>
                    </b-form>
                  </div>
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="repeateAgain">
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>Tarih Ekle</span>
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6" class="mt-5"></b-col>
              <b-col md="6" class="mt-5">
                <b-button class="float-right mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-success"
                  @click="postConfirmText(false, false)">
                  <b-spinner v-if="spinner === true && isDraft === false" small />
                  {{ spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla" }}
                </b-button>
                <b-button class="float-right mt-2 mr-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-warning" @click="postConfirmText(true, false)">
                  <b-spinner v-if="spinner == true && isDraft == true" small />
                  {{
                    spinner == true && isDraft == true
                      ? "Taslağa Kaydediliyor"
                      : "Taslağa Kaydet"
                  }}
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormTimepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    VueTimepicker,
    DragDropImage,
    Editor,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormTimepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      slug: "",
      text: "",
      title: "",
      place: null,
      address:
        "Büyükdere Caddesi Bahar Sokak\nNo:13 River Plaza Kat:28 34394\nŞişli / İstanbul\n\nRIVER PLAZA’YA GELİŞ \n1.Metro ile Geliş \nMetro ile Levent Durağında inince Özdilek AVM oklarını takip ederek, AVM’ye vardıktan sonra, en altta yer alan Özdilek Hipermarket içinden geçip dışarıya çıktıktan sonra hemen sağda River Plaza girişinde direkt kimliğinizi ileterek River Plaza’ya giriş yapabilirsiniz. \n2.Metro veya Otobüsle Gelenler için Alternatif \nAVM bitiminde hemen yanındaki yola saparak (Dede Korkut Sokak üzerinden) Bahar Sokağa giriş yapabilir; River Plaza’nın ana girişinden geçiş yapabilirsiniz. \n3.Araba ile Geliş \nÖzdilek AVM’nin otoparkını kullanarak, otoparka giriş yaptıktan sonra (otopark ücretlidir) en altta yer alan Özdilek Hipermarket içinden geçip dışarıya çıktıktan sonra hemen sağda River Plaza girişinde direkt\nkimliğinizi ileterek River Plaza’ya giriş yapabilirsiniz.",
      formName: "",
      ticketLink: "",
      image: null,
      category: {},
      isDraft: false,
      isHeroHide: false,
      isTicketsAreSoldOut: false,
      linkTitle: "",
      imageTitle: "",
      imageAltText: "",
      featuredImage: require("@/assets/images/placeholder/1440x720.png"),
      metaDescription: "",
      availability: true,
      spinner: false,
      contents: [],
      galleries: [],
      educators: [],
      categories: [],
      eventTypes: [],
      eventFormTemplates: [],
      selectedContent: null,
      selectedGallery: null,
      selectedCategory: null,
      selectedEducators: [],
      selectedEventType: null,
      selectedEventFormTemplate: null,
      educatorsVisibility: true,
      startDate: this.$route.query.startDate,
      startTime: this.$route.query.startTime,
      chars: {
        slug: 255,
        title: 55,
        formName: 255,
        linkTitle: 55,
        imageTitle: 60,
        imageAltText: 140,
        metaDescription: 160,
      },
      dates: [
        {
          id: 1,
          title: null,
          startDate: null,
          endDate: null,
          startTime: null,
          endTime: null,
          endTimeVisibility: false,
        },
      ],
      formIsActive: false,
      nextTodoId: 2,
      locale: "tr-TR",
      showDecadeNav: false,
      hideHeader: false,
      weekday: 0,
      translation: {
        labelPrevDecade: "Önceki on yıl",
        labelPrevYear: "Geçen yıl",
        labelPrevMonth: "Geçen ay",
        labelCurrentMonth: "İçinde bulunduğumuz ay",
        labelNextMonth: "Gelecek ay",
        labelNextYear: "Gelecek yıl",
        labelNextDecade: "Gelecek on yıl",
        labelToday: "Bugün",
        labelSelected: "Seçilen Tarih",
        labelNoDateSelected: "Tarih seçilmedi",
        labelCalendar: "Takvim",
        labelNav: "Takvimde gezinme",
        labelHelp: "Takvimde gezinmek için ok tuşlarını kullanın",
        labelHours: "Saat",
        labelMinutes: "Dakika",
        labelSeconds: "Saniye",
        labelIncrement: "Artır",
        labelDecrement: "Azalt",
        labelSelected: "Seçilen saat",
        labelNoTimeSelected: "Saat seçilmedi",
        labelCloseButton: "Seç",
      },
    };
  },
  watch: {
    title(newTitle, oldTitle) {
      this.slug = newTitle;
      this.linkTitle = newTitle;
      this.imageTitle = newTitle;
      this.imageAltText = newTitle;
    },
    slug(newSlug, oldSlug) {
      this.slug = this.slugify(newSlug);
      this.slugAvailability(this.slug);
    },
    selectedEventType(newEventType, oldEventType) {
      if (newEventType.type != "other") {
        this.educatorsVisibility = true;
      } else {
        this.educatorsVisibility = false;
        this.selectedEducators = [];
      }
    },
    selectedCategory(newCategory, oldCategory) {
      this.getContentsByCategorySlug(newCategory.slug);
      this.selectedContent = null;
    },
  },
  methods: {
    slugify(text, ampersand = "and") {
      const a = "àáäâèéëêıìíïîòóöôùúüûñçßÿỳýœæŕśşńṕẃǵğǹḿǘẍźḧ";
      const b = "aaaaeeeeiiiiioooouuuuncsyyyoarssnpwggnmuxzh";
      const p = new RegExp(a.split("").join("|"), "g");
      return text
        .toString()
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(p, (c) => b.charAt(a.indexOf(c)))
        .replace(/&/g, `-${ampersand}-`)
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
    slugAvailability(slug) {
      let formData = new FormData();
      formData.append("id", null);
      formData.append("slug", slug);
      endpoints
        .postEventsAvailability(formData, this.$i18n.locale, () => { })
        .then((data) => {
          this.availability = data.response.availability;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    repeateAgain() {
      this.dates.push({
        id: (this.nextTodoId += this.nextTodoId),
        title: null,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        endTimeVisibility: false,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.dates.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    onContext(ctx) {
      this.context = ctx;
    },
    handleImageUpload(event) {
      this.image = event.target.files[0];
    },
    postConfirmText(isDraft, preview) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Yeni etkinliği kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit(preview);
        }
      });
    },
    postSubmit(preview) {
      if (this.availability) {
        this.$refs.rules.validate().then((success) => {
          if (success) {
            console.log(this.dates);
            this.dates.forEach((element) => {
              console.log(element);
              if (typeof element.startTime === "object") {
                element.startTime =
                  element.startTime["HH"] + ":" + element.startTime["mm"];
              }
              if (typeof element.endTime === "object") {
                element.endTime = element.endTime["HH"] + ":" + element.endTime["mm"];
              }
            });
            console.log(this.dates);
            this.spinner = true;
            let educatorIds = [];
            let formData = new FormData();
            formData.append("categorySlug", this.selectedCategory.slug);
            formData.append("eventTypeId", this.selectedEventType.id);
            formData.append("slug", this.slug);
            formData.append("text", JSON.stringify(this.$refs.refEditor.value));
            formData.append("title", this.title);
            formData.append("ticketLink", this.ticketLink);
            formData.append("image", this.$refs.refCardImage.image);
            formData.append("dates", JSON.stringify(this.dates));
            formData.append("isDraft", this.isDraft);
            formData.append("isHeroHide", this.isHeroHide);
            formData.append("isTicketsAreSoldOut", this.isTicketsAreSoldOut);
            formData.append("linkTitle", this.linkTitle);
            formData.append("imageTitle", this.imageTitle);
            formData.append("imageAltText", this.imageAltText);
            formData.append("metaDescription", this.metaDescription);
            formData.append("formIsActive", this.formIsActive);

            if (this.formIsActive == true) {
              formData.append("formName", this.formName);
              formData.append("formTemplateId", this.selectedEventFormTemplate.id);
            }

            if (this.place != null) {
              formData.append("place", this.place);
            }
            if (this.address != null) {
              formData.append("address", this.address);
            }
            if (this.selectedContent != null) {
              formData.append("contentId", this.selectedContent.id);
            }
            if (this.selectedGallery != null) {
              formData.append("galleryId", this.selectedGallery.id);
            }
            if (this.educatorsVisibility == true) {
              this.selectedEducators.forEach((element) => {
                educatorIds.push(element.id);
              });
            }
            formData.append("educatorIds", JSON.stringify(educatorIds));

            endpoints
              .postEvents(formData, this.$i18n.locale, () => { })
              .then((data) => {
                this.spinner = false;
                if (data.status) {
                  if (preview == true) {
                    window.open(
                      `${settings.uiBaseUrl}/events/preview/${this.slug}?hl=${this.$i18n.locale}`,
                      "_blank"
                    );
                  }
                  this.$swal({
                    icon: "success",
                    title: "Kayıt başarılı!",
                    text: "Yeni etkinlik eklendi.",
                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                  }).then((result) => {
                    if (result.value) {
                      this.$router.push({
                        path: `/events`,
                      });
                    }
                  });
                } else {
                  this.$swal({
                    title: "Hata!",
                    text: "Etkinlik bağlantı linki benzersiz değil!",
                    icon: "error",
                    confirmButtonText: "Tamam",
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                  }).then((result) => {
                    if (result.value) {
                    }
                  });
                }
              })
              .catch((err) => {
                this.spinner = false;
                console.log(err);
              });
          }
        });
      } else {
        this.$swal({
          title: "Hata!",
          text: "Etkinlik bağlantı linki benzersiz değil!",
          icon: "error",
          confirmButtonText: "Tamam",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then((result) => {
          if (result.value) {
          }
        });
      }
    },
    getEducators() {
      endpoints
        .getEducators(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.educators = [];
          this.educators = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGalleries() {
      endpoints
        .getGalleries(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.galleries = [];
          this.galleries = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEventTypes() {
      endpoints
        .getEventTypes(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.eventTypes = [...data.response];
          this.selectedEventType = this.eventTypes[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFormEventTemplates() {
      endpoints
        .getFormEventTemplates(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.eventFormTemplates = [...data.response];
          this.selectedEventFormTemplate = this.eventFormTemplates[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoriesBySlugFlat() {
      endpoints
        .getCategoriesBySlugFlat(
          this.$i18n.locale == "tr" ? "programlar" : "programs",
          this.$i18n.locale,
          () => { }
        )
        .then((data) => {
          this.categories = [];
          this.categories = [...data.response];
          this.selectedCategory = this.categories[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getContentsByCategorySlug(slug) {
      endpoints
        .getContentsByCategorySlug(slug, this.$i18n.locale, () => { })
        .then((data) => {
          this.contents = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  mounted() {
    this.initTrHeight();
    this.getEducators();
    this.getGalleries();
    this.getEventTypes();
    this.getFormEventTemplates();
    this.getCategoriesBySlugFlat();

    if (this.startDate != null) {
      this.dates[0].startDate = this.startDate;
    }
    if (this.startTime != null) {
      this.dates[0].startTime = this.startTime;
    }
  },
  setup() { },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";

.vue__time-picker>input.display-time {
  border: 1px solid #d2d2d2;
  width: 100%;
  height: 40px;
  padding: 0.3em 0.5em;
  font-size: 1em;
  border-radius: 5px;
}

.vue__time-picker .dropdown ul li:not([disabled]).active {
  background: #e83e8c !important;
  color: #fff;
}

.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: #e83e8c !important;
  color: #fff;
}
</style>
